import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  FormGroup,
  Input,
  UncontrolledTooltip,
} from 'reactstrap';

import { slugify } from '../helpers';

const InputPassword = ({
  id,
  name,
  autoFocus,
  disabled,
  placeholder,
}) => {
  const [visible, setVisible] = useState(false);

  const switchVisibility = () => {
    setVisible(!visible);
  };

  return (
    <FormGroup className="form-group-password">
      <Input
        type={visible ? 'text' : 'password'}
        id={id || name}
        name={name}
        autoFocus={autoFocus}
        disabled={disabled}
        placeholder={placeholder}
      />
      <Button
        id={`v-${slugify(id || name)}`}
        color="link"
        className="password-visibility-switch"
        onClick={switchVisibility}
      >
        {visible ? (
          <i className="far fa-eye-slash" />
        ) : (
          <i className="far fa-eye" />
        )}
      </Button>
      <UncontrolledTooltip fade={false} target={`v-${slugify(id || name)}`}>
        {visible ? 'Hide password' : 'Show password'}
      </UncontrolledTooltip>
    </FormGroup>
  );
};

InputPassword.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

InputPassword.defaultProps = {
  id: null,
  autoFocus: false,
  disabled: false,
  placeholder: 'Password',
};

export default InputPassword;
